import { PancakeTheme } from '@pancakeswap/uikit'
import { createGlobalStyle } from 'styled-components'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Basel';
    font-weight: 535;
    font-style: normal;
    font-display: block;
    src: 
      url('/fonts/Basel-Grotesk-Medium.woff2') format('woff2'),
      url('/fonts/Basel-Grotesk-Medium.woff') format('woff');
  }

  @font-face {
    font-family: 'Basel';
    font-weight: 485;
    font-style: normal;
    font-display: block;
    src: 
      url('/fonts/Basel-Grotesk-Book.woff2') format('woff2'),
      url('/fonts/Basel-Grotesk-Book.woff') format('woff');
  }

  @font-face {
    font-family: 'Newake';
    font-weight: 400;
    font-style: normal;
    font-display: block;
    src: url('/fonts/Newake.otf') format('opentype');
  }

  @font-face {
    font-family: 'Satoshi';
    font-weight: 700;
    font-style: normal;
    font-display: block;
    src: url('/fonts/Satoshi-Bold.otf') format('opentype');
  }

  @font-face {
    font-family: 'Satoshi';
    font-weight: 300;
    font-style: normal;
    font-display: block;
    src: url('/fonts/Satoshi-Light.otf') format('opentype');
  }

  @font-face {
    font-family: 'Satoshi';
    font-weight: 500;
    font-style: normal;
    font-display: block;
    src: url('/fonts/Satoshi-Medium.otf') format('opentype');
  }

  @font-face {
    font-family: 'Satoshi';
    font-weight: 400;
    font-style: normal;
    font-display: block;
    src: url('/fonts/Satoshi-Regular.otf') format('opentype');
  }

  @font-face {
    font-family: 'SF Compact Display';
    font-weight: 400;
    font-style: normal;
    font-display: block;
    src: url('/fonts/SF-Compact-Display-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: 'SF Compact Rounded';
    font-weight: 500;
    font-style: normal;
    font-display: block;
    src: url('/fonts/SF-Compact-Rounded-Medium.ttf') format('truetype');
  }

  @font-face {
    font-family: 'SF Pro Rounded';
    font-weight: 500;
    font-style: normal;
    font-display: block;
    src: url('/fonts/SF-Pro-Rounded-Medium.otf') format('opentype');
  }

  @font-face {
    font-family: 'SF Pro Rounded';
    font-weight: 400;
    font-style: normal;
    font-display: block;
    src: url('/fonts/SF-Pro-Rounded-Regular.otf') format('opentype');
  }

  @font-face {
    font-family: 'Space Grotesk';
    font-weight: 700;
    font-style: normal;
    font-display: block;
    src: url('/fonts/SpaceGrotesk-Bold.otf') format('opentype');
  }

  @font-face {
    font-family: 'IBM Plex Mono';
    font-weight: 700;
    font-style: normal;
    font-display: block;
    src: url('/fonts/IBMPlexMono-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: 'OCR A';
    src: url('/fonts/OCRA/OCRA.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  * {
    font-family: 'Kanit', sans-serif;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background-color: ${({ theme }) => theme.colors.background};
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.25);
    position: relative;

    img {
      height: auto;
      max-width: 100%;
    }
  }

  #__next {
    position: relative;
    z-index: 1;
  }

  #portal-root {
    position: relative;
    z-index: 2;
  }
`

export default GlobalStyle
